// extracted by mini-css-extract-plugin
export default {"price":"z1-z","onSale":"A1-z","msrpLabelPrice":"B1-z","msrpLabel":"C1-z","originalPrice":"D1-z","percentOff":"E1-z"};